import React, { Suspense, lazy, useRef, useState, useContext, useEffect } from "react";
import { Link, useNavigate , NavLink } from "react-router-dom";
import { ToastContainer, toast, Zoom } from 'react-toastify';
import  { apibaseURl , currencySymbol , errorToast , successToast , loggedInCustomerDetails }  from "../../functions/Function";
import  { WebContext }  from "../../Webroute";
const  Sell = (props) => {
    const WebData = useContext(WebContext);
   const [id, setId] = useState(0); 
   const [name, setName] = useState(''); 
   const [qty, setQty] = useState(1); 
   const [price, setPrice] = useState(props.sell.product_current_price); 
   const [total, setTotal] = useState(props.sell.product_current_price); 

  
    const changePrice = (price) =>
    {
      setPrice(price)
      var totalPrice = qty*price;
      setTotal(totalPrice);
   }

   const changeQty = (qty) =>
    {
      setQty(qty)
      var totalPrice = qty*price;
      setTotal(totalPrice);
   }
   
   const handleSubmitSellOrder = async (e) => {
      e.preventDefault();
      
      try {
        let res = await fetch(apibaseURl + "sellorder", {
          method: "POST",
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            user_id: loggedInCustomerDetails('id'),
            price: price,
            qty: qty,
            product_id: props.sell.product_id
         }),
        });
      
        let output = await res.json();
         if (res.status == 200) {
            console.log(output)
            if (output.result == true) {
                  successToast('Your order has been successfully placed' , 'bottom-right' , 1500  , true);  
                  props.close();
                  props.updatePorfolioList();
                  WebData.fetchWallet()
            }else
            {
                  errorToast(output.response , 'bottom-right' , 1500  , true);
            }
         }
      } catch (err) {
               console.log(err)
      }
    };

  

    useEffect(() => {
      setName(props.sell.product_name);
      setPrice(props.sell.product_current_price);
      setQty(1);
      setTotal(props.sell.product_current_price);
    }, [props])
   
  return (
    <> 
        <ToastContainer />
        { props.show == true && 
         <> 
            
            <div className="sellSticky">
                <span className="sellStickyclose" onClick={()=> props.close()} ><i className="fa fa-times"></i></span>
                <div className="container">
                    <form onSubmit={handleSubmitSellOrder} >
                            <div className="form-row">
                            <div className="col-12">
                                <h3 className="sellSticky-title">
                                  {name}
                                </h3>
                            </div>
                            <div className="col-lg-4 col-sm-12">
                                <label>Cuurent Price</label>
                                <input 
                                    type="number" 
                                    className="form-control" 
                                    placeholder=""
                                    value={price}
                                    onChange={(e) => changePrice(e.target.value)}
                                  />
                            </div>
                            <div className="col-lg-2 col-sm-12">
                                <label>Qty</label>  
                                <input 
                                    type="number" 
                                    className="form-control" 
                                    placeholder=""
                                    value={qty}
                                    onChange={(e) => changeQty(e.target.value)}
                                    />
                            </div>
                            <div className="col-lg-4 col-sm-12">
                                <label>Total</label>  
                                <input 
                                    type="number" 
                                    className="form-control" 
                                    placeholder="" 
                                    value={total}
                                    readOnly={true}
                                />
                            </div>
                            <div className="col-lg-2 col-sm-12">
                                <label></label>  
                                <button type="submit" className="btn ivo-site-btn buy-sell">SELL</button>
                            </div>

                            
                            </div>
                            </form>
                </div>
            </div>
         </>
         }
    </>

  );
}

export default Sell;
